import { QueryClient } from '@tanstack/react-query';

/**
 * TanStack Query Client Configuration
 * Centralized configuration for React Query
 */

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // How long data is considered "fresh" (no refetch while fresh)
      staleTime: 1000 * 60 * 5, // 5 minutes
      
      // How long unused data stays in cache
      gcTime: 1000 * 60 * 30, // 30 minutes (previously called cacheTime)
      
      // Retry failed requests
      retry: 1,
      
      // Refetch on window focus for real-time feel
      refetchOnWindowFocus: true,
      
      // Don't refetch on mount if data is fresh
      refetchOnMount: true,
      
      // Handle errors globally
      throwOnError: false,
    },
    mutations: {
      // Retry failed mutations once
      retry: 1,
      
      // Handle errors globally
      throwOnError: false,
    },
  },
});

/**
 * Query Keys Factory
 * Centralized query key management for consistent cache invalidation
 */
export const queryKeys = {
  // Companies
  companies: {
    all: ['companies'],
    list: (filters) => ['companies', 'list', filters],
    detail: (id) => ['companies', 'detail', id],
    tasks: (id) => ['companies', id, 'tasks'],
    branches: (id) => ['companies', id, 'branches'],
    servers: (id) => ['companies', id, 'servers'],
  },
  
  // Branches
  branches: {
    all: ['branches'],
    detail: (id) => ['branches', 'detail', id],
    onboarding: (id) => ['branches', id, 'onboarding'],
    notes: (id) => ['branches', id, 'notes'],
  },
  
  // Users
  users: {
    all: ['users'],
    list: (filters) => ['users', 'list', filters],
    detail: (id) => ['users', 'detail', id],
    technicians: ['users', 'technicians'],
    current: ['users', 'current'],
  },
  
  // Tasks
  tasks: {
    all: ['tasks'],
    byCompany: (companyId) => ['tasks', 'company', companyId],
    detail: (id) => ['tasks', 'detail', id],
  },
  
  // Audit Logs
  auditLogs: {
    all: ['auditLogs'],
    list: (filters) => ['auditLogs', 'list', filters],
  },
};

export default queryClient;

